import React from 'react';
import api from '../../helpers/api';

import styles from './ClinicDetails.module.scss';
import Loader from '../miscellaneous/Loader/Loader';
import MultiSelect from '../miscellaneous/MultiSelect/MultiSelect';
import Tooltip from '../miscellaneous/Tooltip/Tooltip';
import {FaEdit} from 'react-icons/fa';
import {$t} from '../../helpers/translator';
import Modal from '../miscellaneous/Modal/Modal';
import _ from "lodash";

import {connect} from "react-redux";
import {setAlert} from "../../store/alerts-slice";
import {getCountries} from "../../store/data-slice";
import {getUserClinic} from "../../store/auth-slice";
import HasPermission from 'helpers/permissions/HasPermission';


class ClinicDetails extends React.Component {
    constructor(props) {
        super(props);
        // this.logoRef = React.createRef();

        this.state = {
            clinicId: this.props.clinicId ? this.props.clinicId : null,
            clinicType: this.props.clinicType ? this.props.clinicType : 2,
            translations: {},
            userType: this.props.userType ? this.props.userType : 2,
            showEditDetails: false,

            currentData: {
                id: '',
                clinic_number: '',
                name: '',
                phone: '',
                city: '',
                email: '',
                address: '',
                country: 0,
                parent_clinic: null
            },

            formData: {},
            formDataErrors: {
                id: '',
                clinic_number: '',
                name: '',
                phone: '',
                city: '',
                email: '',
                address: '',
                country: '',
            },
            formError: '',  //from server
            uploadingImage: false,
        };

        // store.subscribe(() => {
        //     // When state will be updated(in our case, when items will be fetched),
        //     // we will update local component state and force component to rerender
        //     // with new data.
        //
        //     this.setState({
        //         countries: store.getState().data.countries
        //     }, () => {
        //         console.log('got contries')
        //     });
        // });

    }

    async componentDidMount() {
        let userType = this.props.userType ? this.props.userType : 2;   //fallback to type clinic if not provided
        let translations = {
            2: {
                clinicDetails: $t('global.account.clinicDetails'),
                editClinicDetails: $t('global.account.editClinicDetails'),
                clinicId: $t('global.account.clinicId'),
                clinicNumber: $t('global.account.clinicNumber'),
                clinicStatus: $t('global.account.clinicStatus'),
                clinicName: $t('global.account.clinicName'),
                clinicPhoneNumber: $t('global.account.clinicPhoneNumber'),
                clinicEmail: $t('global.account.clinicEmail'),
                updateClinicData: $t('global.account.updateClinicData'),
            },
            3: {
                clinicDetails: $t('global.account.chainDetails'),
                editClinicDetails: $t('global.account.editChainDetails'),
                clinicId: $t('global.account.chainId'),
                clinicNumber: $t('global.account.chainNumber'),
                clinicStatus: $t('global.account.chainStatus'),
                clinicName: $t('global.account.chainName'),
                clinicPhoneNumber: $t('global.account.chainPhoneNumber'),
                clinicEmail: $t('global.account.chainEmail'),
                updateClinicData: $t('global.account.updateChainData'),
            }
        }
        
        await this.getClinicDetails();
        await this.getCountries();

        if (!translations) {
            this.setState({
                userType: userType
            })
        } else {
            const translationsToUse = translations[this.state.clinicType];
            this.setState({
                translations: translationsToUse,
                userType: userType
            })
        }
    }

    async getClinicDetails() {
        let clinic = null;
        try {
            if (this.props.clinicId) {
                let res = await api.get(`account/clinic?clinic_id=${this.props.clinicId}`);
                if (res && res.success) {
                    clinic = res.data.data;
                }
            } else {
                clinic = await this.props.dispatch(getUserClinic(true))
            }
            if (!clinic) {
                return;
            }

            let data = {
                id: clinic.id,
                clinic_number: clinic.clinic_number,
                name: clinic.name,
                phone: clinic.phone,
                city: clinic.city,
                email: clinic.email,
                address: clinic.address,
                country: clinic.country,
                logo: clinic.logo
            };

            this.setState({
                currentData: data,
                formData: data,
                uploadingImage: false,
                clinicType: clinic.is_chain ? 3 : 2,
                parent_clinic: clinic.parent_clinic
            }, () => {
                // console.log('sttstts', data)
            });

        } catch (e) {
            console.error('err getting user', e)
        }
    }

    async getCountries() {
        try {
            let res = await this.props.dispatch(getCountries());
            if (res) {
                this.setState({countries: res})
            }
        } catch (e) {
            console.error('err getting countries,', e);
        }
    }

    closeModals() {
        let currentData = {...this.state.currentData};
        let formDataErrors = {...this.state.formDataErrors};

        _.forEach(formDataErrors, (v, k) => {
            formDataErrors[k] = '';
        });

        this.setState({
            formData: currentData,
            formDataErrors: formDataErrors,
            showEditDetails: false,
            loading: false,
            success: false,
        });
    }

    fieldChangeHandler(e) {
        let formData = {...this.state.formData};
        formData[e.target.name] = e.target.value;
        this.setState({formData: formData});
    }

    countryChangeHandler(data) {
        let formData = {...this.state.formData};
        formData.country = data.value;
        this.setState({formData: formData});
    }

    getCountryNameById(id) {
        let res = _.findIndex(this.state.countries, function (o) {
            return o.id === id;
        });

        if (res < 0) {
            return 'N/A';
        }

        return $t('countries.' + this.state.countries[res].name);
    }

    async updateClinicData() {
        let reg;

        let formData = {...this.state.formData}
        let formDataErrors = {...this.state.formDataErrors}
        _.forEach(formDataErrors, (v, k) => {
            formDataErrors[k] = '';
        })

        if (formData.name) {
            formData.name = formData.name.replace(/\s+/g, ' ');
        }
        if (!formData.name) {
            formDataErrors.name = $t('global.account.clinicNameRequired')
        } else if (formData.name.length > 35) {
            formDataErrors.name = $t('global.account.maxLength35')
        }

        reg = /\S+@\S+\.\S+/;
        if (!formData.email) {
            formDataErrors.email = $t('global.account.clinicEmailRequired')
        } else if (!reg.test(formData.email)) {
            formDataErrors.email = $t('global.account.enterValidEmailAddress');
        }

        reg = /^[0-9 ().+#\-]*$/
        if (formData.phone) {
            formData.phone = formData.phone.replace(/\s+/g, ' ');
        }
        if (formData.phone && !reg.test(formData.phone)) {
            formDataErrors.phone = $t('global.account.enterValidPhoneNumber')
        } else if (formData.phone && (formData.phone.length < 5 || formData.phone.length > 20)) {
            formDataErrors.phone = $t('global.account.enterValidPhoneNumber')
        }

        this.setState({formDataErrors: formDataErrors})

        let errors = false;
        _.forEach(formDataErrors, (v, k) => {
            if (v) {
                errors = true;
            }
        })

        if (!errors) {
            this.setState({loading: true}, async () => {
                try {
                    let payload = {
                        clinic_id: this.state.clinicId,
                        clinicPhone: formData.phone,
                        clinicName: formData.name,
                        clinicEmail: formData.email,
                        clinicAddress: formData.address,
                        clinicCity: formData.city,
                        clinicCountry: formData.country,
                    }
                    // let res = await api.updateClinicAccount(payload);
                    let res = await api.post('account', payload)
                    if (res && res.data && res.data.success) {
                        // window.location.reload();
                        let res = await this.props.dispatch(setAlert({type: 'success'}));
                        await this.getClinicDetails();
                        this.props.onClinicNameChange(payload.clinicName)

                    }
                    this.setState({loading: false, showEditDetails: false})
                } catch (e) {
                    console.error('err updating clinic', e)
                    this.setState({loading: false})
                }
            })
        }
    }

    uploadLogoClickHandler() {
        if (this.state.parent_clinic) {
            return;
        }

        this.setState({imageError: ''}, () => {
            this.inputElement.click();
        });
    }

    async logoSelectedHandler(e) {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0];
            let error = '';

            if (img.size > 5242880) {
                error = $t('global.account.imgMaxSize5mb');
            }
            if (!img.type.includes('image')) {
                error = $t('global.account.onlyImagesAllowed');
            }

            if (error) {
                this.setState({imageError: error});
                return;
            }

            this.setState({uploadingImage: true}, () => {
                let reader = new FileReader();
                reader.readAsDataURL(img);

                reader.onload = async () => {
                    let imgBase64 = reader.result;
                    // console.log(imgBase64)
                    try {
                        // let res = await api.updateLogo(imgBase64);
                        let res = await api.post('account/logo', {
                            image: imgBase64,
                            clinic_id: this.state.clinicId,
                        })

                        if (res && res.data && res.data.success) {
                            await this.getClinicDetails();
                        } else {
                            this.setState({
                                imageError: $t('global.account.uploadFailed'),
                                uploadingImage: false
                            });
                        }

                    } catch (e) {
                        console.error('err uploading img:', e);
                        this.setState({uploadingImage: false});
                    }
                };
            });
        }
    }

    renderEditClinicDetails() {

        let translations = this.state.translations;
        return (
            <div className={styles['rodal-container']}>
                <div className={styles['rodal-container']}>
                    {this.state.success ?
                        <div className={styles['success-message']}>{$t('global.account.success')}</div>
                        :
                        <div>
                            <div className={styles.row}>
                                <div className={styles['rodal-header']}>{translations?.editClinicDetails}</div>
                            </div>

                            <div className={'alma-fields-row'}>
                                <div className={'alma-field-container'}>
                                    <div className={'alma-field-header'}>{translations?.clinicName}</div>
                                    <input name="name"
                                           className={'alma-input'}
                                           type="text"
                                           value={this.state.formData.name}
                                           onChange={(e) => this.fieldChangeHandler(e)}/>
                                </div>
                            </div>
                            <div className={styles['error-text']}>{this.state.formDataErrors.name}</div>

                            <div className={'alma-fields-row'}>
                                <div className={'alma-field-container'}>
                                    <div className={'alma-field-header'}>{translations?.clinicPhoneNumber}</div>
                                    <input name="phone"
                                           className={'alma-input'}
                                           type="tel"
                                           value={this.state.formData.phone}
                                           onChange={(e) => this.fieldChangeHandler(e)}/>
                                </div>
                            </div>
                            <div className={styles['error-text']}>{this.state.formDataErrors.phone}</div>

                            <div className={'alma-fields-row'}>
                                <div className={'alma-field-container'}>
                                    <div className={'alma-field-header'}>{translations?.email}</div>
                                    <input name="email"
                                           className={'alma-input'}
                                           type="text"
                                           value={this.state.formData.email}
                                           onChange={(e) => this.fieldChangeHandler(e)}/>
                                </div>
                            </div>
                            <div className={styles['error-text']}>{this.state.formDataErrors.email}</div>

                            <div className={'alma-fields-row'}>
                                <div className={'alma-field-container'}>
                                    <div className={'alma-field-header'}>{$t('global.account.country')}</div>
                                    <MultiSelect
                                        // styles={{marginLeft: '5px'}}
                                        searchable
                                        options={this.state.countries}
                                        placeholder={$t('global.account.country')}
                                        onValueChange={(data) => this.countryChangeHandler(data)}
                                        selected={{
                                            label: this.getCountryNameById(this.state.formData.country),
                                            value: this.state.formData.country
                                        }}
                                    />
                                </div>

                            </div>
                            <div className={styles['error-text']}>{this.state.formDataErrors.country}</div>

                            <div className={'alma-fields-row'}>
                                <div className={'alma-field-container'}>
                                    <div className={'alma-field-header'}>{$t('global.account.city')}</div>
                                    <input name="city"
                                           className={'alma-input'}
                                           type="text"
                                           value={this.state.formData.city}
                                           onChange={(e) => this.fieldChangeHandler(e)}/>
                                </div>
                            </div>
                            <div className={styles['error-text']}>{this.state.formDataErrors.city}</div>


                            <div className={'alma-fields-row'}>
                                <div className={'alma-field-container'}>
                                    <div className={'alma-field-header'}>{$t('global.account.streetAndNumber')}</div>
                                    <input name="address"
                                           className={'alma-input'}
                                           type="text"
                                           value={this.state.formData.address}
                                           onChange={(e) => this.fieldChangeHandler(e)}/>
                                </div>
                            </div>
                            <div className={styles['error-text']}>{this.state.formDataErrors.address}</div>

                            {this.state.loading ?
                                <Loader/>
                                :
                                <div className={`${styles.row} ${styles['flex-end']}`} style={{marginTop: '20px'}}>
                                    <div className={'alma-button'}
                                         onClick={() => this.updateClinicData()}>
                                        {$t('global.account.save')}
                                    </div>
                                </div>
                            }
                            <div className={`${styles.row} ${styles['error-text']} ${styles['flex-end']}`}>
                                {this.state.formError}
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }

    render() {
        let translations = this.state.translations;
        let logoRoute = this.state.currentData.logo ? this.state.currentData.logo : 'assets/alma_logo_w.png';

        let countryIndex = -1;
        if (this.state.currentData && this.state.currentData.country && this.state.countries) {
            let countries = this.state.countries;
            let countryId = this.state.currentData.country

            countryIndex = _.findIndex(countries, function (o) {
                return o.id === countryId
            });
        }

        let country = this.state.countries && countryIndex && countryIndex >= 0 && this.state.countries[countryIndex] ? $t('countries.' + this.state.countries[countryIndex].name) : '';
        let city = this.state.currentData.city ? ', ' + this.state.currentData.city : '';
        let street = this.state.currentData.address ? ', ' + this.state.currentData.address : '';
        let address = country + city + street;
        address = address ? address : 'N/A'

        return (
            // <div>
            <div className={`alma-box ${styles.container}`}>
                {Object.keys(translations).length === 0 && <div className={styles.loader}><Loader/></div>}
                <div className={'alma-box-header'}>
                    <span><h3>{translations?.clinicDetails}</h3></span>

                    <HasPermission permission="account:edit">
                    {this.props.userType === 4 ?
                        null
                        :
                        <Tooltip
                            content={translations?.editClinicDetails}>
                            <FaEdit className={styles['info-icon']}
                                    onClick={() => this.setState({showEditDetails: true})}/>
                        </Tooltip>}
                    </HasPermission>
                </div>

                <div className={styles['flex-main']}>
                    <input ref={input => this.inputElement = input} type="file" name="myImage"
                           onChange={(e) => this.logoSelectedHandler(e)} style={{display: 'none'}}/>
                    {
                        this.props.clinicId ?
                            null
                            :
                            <div className={styles['image-container']}>
                                <div>
                                    <div
                                        className={`${styles['logo-container']} ${(!this.state.parent_clinic ? styles.pointer : null)}`}
                                        onClick={() => this.uploadLogoClickHandler()}>

                                        <div className={styles['logo']} style={{
                                            backgroundImage: `url("${logoRoute}")`,
                                            backgroundSize: 'cover',
                                        }}>
                                            {this.state.uploadingImage ?
                                                <div style={{marginTop: '60px'}}>
                                                    <Loader color={'white'}/>
                                                </div>
                                                :
                                                null
                                            }
                                        </div>

                                    </div>
                                    <div className={styles['image-error']}>{this.state.imageError}</div>
                                </div>
                            </div>
                    }

                    <div>
                        <div className={styles.row}>
                            <div className={styles.header}>{translations?.clinicId}:</div>
                            <div className={styles.value}>{this.state.currentData.id}</div>
                        </div>
                        <div id="clinicNumber" className={styles.row}>
                            <div className={styles.header}>{translations?.clinicNumber}:</div>
                            <div className={styles.value}>{this.state.currentData.clinic_number}</div>
                        </div>
                        {
                            this.state.userType === 2 ?
                                <div className={styles.row}>
                                    <div className={styles.header}>{translations?.clinicStatus}:</div>
                                    <div
                                        className={styles.value}>{this.state.parent_clinic ? $t('global.account.partOfChain') + ' (' + this.state.parent_clinic + ')' : $t('global.account.independent')}</div>
                                </div>
                                :
                                null
                        }
                        <div className={styles.space}/>
                        <div className={styles.row}>
                            <div className={styles.header}>{translations?.clinicName}:</div>
                            <div
                                className={styles.value}>{this.state.currentData.name ? this.state.currentData.name : 'N/A'}</div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.header}>{translations?.clinicPhoneNumber}:</div>
                            <div
                                className={styles.value}>{this.state.currentData.phone ? this.state.currentData.phone : 'N/A'}</div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.header}>{translations?.clinicEmail}:</div>
                            <div
                                className={styles.value}>{this.state.currentData.email ? this.state.currentData.email : 'N/A'}</div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.header}>{$t('global.account.address')}:</div>
                            <div
                                className={styles.value}>{address}</div>
                        </div>

                    </div>
                </div>
                {/*</div>*/}

                <Modal content={this.renderEditClinicDetails()}
                       onClose={this.closeModals.bind(this)}
                       visible={this.state.showEditDetails}/>
            </div>
        );
    }

}

ClinicDetails.defaultProps = {
    onClinicNameChange: () => {
    },
    clinicId: null,
    clinicType: 2,
    userType: 2
}


const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(ClinicDetails);
